[...document.getElementsByClassName('remove-attachment')].forEach(el => {
    el.addEventListener('click', e => {

        e.preventDefault();

        const
            attachmentId = el.dataset.attachmentId,
            removeInput = document.getElementById('remove-attachment');

        if (removeInput.value === '') {
            removeInput.value = attachmentId

        } else {
            removeInput.value = removeInput.value + ',' + attachmentId

        }

        document.getElementById('attachment-' + attachmentId).hidden = true;

    })

})